<script>
import { mapGetters } from "vuex";

/**
 * Renders the company's bank account block from the print profile. Picks the
 * default account by default; pass `accountId` to force a specific one.
 *
 * If the profile has `showBankDetailsOnInvoice = false`, this renders nothing.
 *
 * Filtered by voucher type: an account with `showOnVoucherTypesCsv` set is
 * shown only when the prop `voucherType` is in that CSV (empty CSV = all).
 */
export default {
  name: "PrintBankDetailsBlock",
  inject: { printProfile: { default: () => () => null } },
  props: {
    voucherType: { type: String, default: null },
    accountId: { type: [Number, String], default: null },
  },
  computed: {
    ...mapGetters("printProfile", { bankAccounts: "bankAccounts" }),
    profile() { return this.printProfile(); },
    visible() {
      return !!(this.profile?.showBankDetailsOnInvoice) && !!this.account;
    },
    eligibleAccounts() {
      const t = this.voucherType;
      return (this.bankAccounts || []).filter((a) => {
        if (!a.showOnVoucherTypesCsv) return true;
        if (!t) return true;
        return a.showOnVoucherTypesCsv.split(",").map((s) => s.trim()).includes(t);
      });
    },
    account() {
      if (this.accountId != null) {
        return this.eligibleAccounts.find((a) => String(a.id) === String(this.accountId)) || null;
      }
      return this.eligibleAccounts.find((a) => a.isDefault) || this.eligibleAccounts[0] || null;
    },
  },
};
</script>

<template>
  <div v-if="visible" class="print-bank-block">
    <div class="print-bank-row">
      <div>
        <div class="print-bank-label">Bank</div>
        <div class="print-bank-value">{{ account.bankName }}</div>
      </div>
      <div>
        <div class="print-bank-label">A/C No.</div>
        <div class="print-bank-value">{{ account.accountNumber }}</div>
      </div>
      <div>
        <div class="print-bank-label">IFSC</div>
        <div class="print-bank-value">{{ account.ifsc }}</div>
      </div>
      <div v-if="account.branch">
        <div class="print-bank-label">Branch</div>
        <div class="print-bank-value">{{ account.branch }}</div>
      </div>
    </div>
  </div>
</template>
